export const isEmpty = (obj) => Object.keys(obj).length === 0;

export const toLong = (str) => {
  const num = Number(str);
  return isNaN(num) ? null : num;
};